import React from "react";

const profile = React.createContext();

export default profile;
